module.exports = __webpack_public_path__ + "img/labmemtest_text_nextbtn_tc.626e31ca.png";